import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logoutSuccess } from '../../redux/reducers/auth';
import { getCommonInfo } from '../../services/Api';
import { decodeToken } from '../../utils';
import JWTRemainingTime from './JWTRemainingTime';

const Header = () => {
    const [info, setInfo] = useState({});
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const token = login.token;
    const decode = decodeToken(token);
    const [remainingTime, setRemainingTime] = useState(0);
    const [showRenewButton, setShowRenewButton] = useState(false);

    const RENEWAL_THRESHOLD = 120 * 60 * 1000;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (loggedIn) {
            getCommonInfo()
                .then(({ data }) => {
                    setInfo(data);
                })
                .catch((error) => console.log(error));
        }
    }, [loggedIn]);

    const handleLogout = () => {
        dispatch(logoutSuccess());
        navigate('/');
    };
    const siteLinks = [
        { label: '신흥', url: 'http://www.shinhung.co.kr/' },
        { label: '덴탈캠퍼스', url: 'https://www.dentalcampus.co.kr/' },
        { label: '덴탈잡', url: 'https://www.dentaljob.co.kr/' },
        { label: '덴탈비타민', url: 'http://www.dentalvitamin.com/' },
        { label: '덴탈세미나', url: 'https://www.dentalseminar.co.kr/' },
        { label: '골드니안', url: 'http://www.goldenian.com/' },
        { label: '덴탈엑스포', url: 'http://www.dentalexpo.co.kr/' },
        { label: '키즈크라운(영문)', url: 'https://www.kidscrown.com/' },
        { label: '키즈크라운(중문)', url: 'http://cn.kidscrown.com/' },
        { label: 'SIS(국문)', url: 'http://www.shinhungimplant.co.kr/' },
        { label: 'SIS(영문)', url: 'http://www.shinhungimplant.com/' },
    ];

    const handleSiteLinkChange = (e) => {
        const url = e.target.value;
        if (url) {
            window.open(url, '_blank');
        }
    };

    const calculateRemainingTime = () => {
        if (!decode) return;

        const expirationTime = decode.exp * 1000;
        const currentTime = Date.now();
        const timeRemaining = expirationTime - currentTime;

        if (timeRemaining <= 0) {
            dispatch(logoutSuccess());
            setShowRenewButton(false);
            setRemainingTime(0);
            return;
        }

        setRemainingTime(timeRemaining);
        setShowRenewButton(timeRemaining < RENEWAL_THRESHOLD);
    };

    useEffect(() => {
        calculateRemainingTime();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (remainingTime > 0) {
            const timer = setInterval(() => {
                setRemainingTime((prev) => {
                    if (!prev) return null;

                    const updated = prev - 1000;
                    if (updated <= 0) {
                        clearInterval(timer);
                        setShowRenewButton(false);
                        return null;
                    }

                    setShowRenewButton(updated < RENEWAL_THRESHOLD);
                    return updated;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
        // eslint-disable-next-line
    }, [remainingTime]);
    return (
        <header>
            <div className="container">
                <Link to="/mabaa010">
                    <img className="img-logo" src="./images/logo.png" alt="DentalJob Logo" />
                </Link>
                <ul className="auth-navigate">
                    <li>
                        <a href="https://devu.dentaljob.co.kr" target="_blank" rel="noopener noreferrer">
                            덴탈잡 홈페이지
                        </a>
                    </li>
                    <li>|</li>
                    <li>
                        <select
                            defaultValue=""
                            onChange={handleSiteLinkChange}
                            style={{ border: '1px solid #ddd', padding: '3px', borderRadius: '3px', cursor: 'pointer' }}
                        >
                            <option value="" disabled>
                                사이트 링크
                            </option>
                            {siteLinks.map((item, idx) => (
                                <option key={idx} value={item.url} style={{ cursor: 'pointer' }}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </li>
                    <li>|</li>
                    <li>
                        <span style={{ cursor: 'default' }}>{info.nameKor} 님</span>
                    </li>
                    <li>|</li>
                    {showRenewButton && (
                        <>
                            <li>
                                <JWTRemainingTime decode={decode} />
                            </li>
                            <li>|</li>
                        </>
                    )}
                    <li>
                        <button className="btn btn-secondary btn-rounded" onClick={handleLogout}>
                            로그아웃
                        </button>
                    </li>
                </ul>
            </div>
        </header>
    );
};

export default Header;
